import {TheBorderXNudgeSymbol} from "../reels/TheBorderXNudgeSymbol";
import {TheBorderSymbol} from "../reels/TheBorderSymbol";
import {ISymbolPosition} from "../../core/reel/ReelInterfaces";

/**
 * Created by Jerker Nord on 2022-05-05.
 */

export class TheBorderSymbols {

    private _symbols:TheBorderSymbol[];

    constructor() {

    }

    public init():void {
        this._symbols = [];
        //We need an extra 6 syms since last reel doesn't always have time to remove all syms before new ones are added
        for(let i:number = 0; i < 84; i++) {
            this._symbols.push(this.createNewSymbol());
        }
    }

    private createNewSymbol():TheBorderSymbol{
        return new TheBorderSymbol();
    }

    public getSymbol(symbolName:string):TheBorderSymbol {
        for(let i:number = 0; i < this._symbols.length; i++) {
            if(this._symbols[i].isUsed == false) {
                this._symbols[i].isUsed = true;
                this._symbols[i].symbolName = symbolName;
                return this._symbols[i];
            }
        }
        this._symbols.push(this.createNewSymbol());
        return this.getSymbol(symbolName);
    }
}